import React from 'react';
import PropTypes from 'prop-types';
import { getDisplayName, numberWithSpaces } from 'shared/helpers/common';
import { getMonthlyPrice, calculateExchange } from 'shared/helpers/leasing/utils';
// import { autoMoneyCalculate } from 'shared/helpers/leasing/autoMoneyCalculate';
import { ulfCalculate } from 'shared/helpers/leasing/ulfCalculate';
import {
  isUlfSomeDealersLeasingProposalAvailable,
  isUlf24LeasingProposalAvailable,
} from 'shared/helpers/leasing/myAuto';
import { getPrice } from 'shared/helpers/advert';

import { withFetch } from './withFetch';

export const withLeasingParams = WrappedComponent => {
  const Component = class extends React.Component {
    static displayName = `withLeasingParams(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      advert: PropTypes.shape().isRequired,
      fetch: PropTypes.func.isRequired,
      leasingParams: PropTypes.shape(),
      index: PropTypes.number,
      partner: PropTypes.string,
    };

    static defaultProps = {
      index: 0,
      partner: '',
      leasingParams: null,
    };

    state = {
      leasingParams: {},
    };

    componentWillMount = () => {
      const { advert, leasingParams: existsLeasingParams } = this.props;
      let leasingParams;
      if (!advert || !advert.id) return;

      if (existsLeasingParams && existsLeasingParams.monthlyPayment) {
        leasingParams = existsLeasingParams;
      } else if (isUlfSomeDealersLeasingProposalAvailable(advert)) {
        leasingParams = this.addUlfParams(advert);
      } else { //  else if (isUlf24LeasingProposalAvailable(advert)) {
        leasingParams = this.addUlfParams(advert, true);
      }
      // } else {
      //   leasingParams = this.addAutoMoneyParams(advert);
      // }

      if (leasingParams && leasingParams.monthlyPayment) {
        this.setState({ leasingParams: this.addExtendedParams(leasingParams) });
      }
    };

    addExtendedParams = leasingParams => {
      const { advert } = this.props;
      const newLP = { ...leasingParams };

      if (newLP.extendedParams) return newLP;

      const monthlyPaymentUAH = getMonthlyPrice(
        this.props.advert,
        newLP.monthlyPayment, // USD as default
        'uah',
        false,
      );
      const monthlyPaymentUAHFormatted = numberWithSpaces(monthlyPaymentUAH);
      const priceUAH = getPrice(advert.price, ['uah']);
      const prepaidUAH = calculateExchange(advert.price, leasingParams.prepaidSum, 'uah');

      newLP.extendedParams = {
        monthlyPaymentUAH,
        monthlyPaymentUAHFormatted,
        priceUAH,
        prepaidUAH,
      };
      return newLP;
    };

    /**
     * Default currency is USD
     */
    // addAutoMoneyParams = advert => {
    //   const priceUSD = getPrice(advert.price, ['usd']);
    //   const { monthly, avans } = autoMoneyCalculate(priceUSD);
    //   const leasingParams = {
    //     monthlyPayment: monthly,
    //     prepaidSum: avans,
    //     isAutoMoneyCalculated: true,
    //   };
    //   this.setState({ leasingParams });
    //   return leasingParams;
    // };

    addUlfParams = (advert, isUlf24Calculated = false) => {
      const priceUSD = getPrice(advert.price, ['usd']);
      const { monthly, avans } = ulfCalculate(priceUSD);
      const leasingParams = {
        monthlyPayment: monthly,
        prepaidSum: avans,
        isUlfCalculated: !isUlf24Calculated,
        isUlf24Calculated,
      };
      this.setState({ leasingParams });
      return leasingParams;
    };

    render() {
      return <WrappedComponent {...this.props} leasingParams={this.state.leasingParams} />;
    }
  };

  return withFetch(Component);
};



// WEBPACK FOOTER //
// ./src/shared/hocs/withLeasingParams.js